import { render } from "./UploadFilesBox.vue?vue&type=template&id=baf86d3e&scoped=true"
import script from "./UploadFilesBox.vue?vue&type=script&lang=js"
export * from "./UploadFilesBox.vue?vue&type=script&lang=js"

import "./UploadFilesBox.vue?vue&type=style&index=0&id=baf86d3e&scoped=true&lang=css"

import exportComponent from "/var/www/cargo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-baf86d3e"]])

export default __exports__